const UNSPLASH_ACCESS_KEY = 'HNwSPe4ZCTSwjLyyX5_GtSoOSrd44Q7lQQUDNiTdWbY';//process.env.REACT_APP_UNSPLASH_ACCESS_KEY;
const UNSPLASH_API_URL = 'https://api.unsplash.com/search/photos';

// Enhanced places.ts with improved location context and fallback handling
import { Location } from '../types/chat';
import { Loader } from '@googlemaps/js-api-loader';
//import { GOOGLE_MAPS_CONFIG } from '../config/maps';




console.log('[Unsplash] Using API key:', UNSPLASH_ACCESS_KEY?.substring(0, 10) + '...');


// Configuration
const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes
const MAX_PHOTOS = 10;
const DEFAULT_PLACEHOLDER = '/placeholder-image.png';
const REQUEST_THROTTLE = 1000; // 1 second minimum between requests
const PEXELS_API_KEY = 'k9ere4FT4QeImnei0CXJNP2ontyGXSy4hPwPnKpbj7GygwHbbxHLF2Vf';//process.env.REACT_APP_PEXELS_API_KEY;


// Service state
let mapsLoader: Loader | null = null;
let placesService: google.maps.places.PlacesService | null = null;
let lastRequestTimestamp = 0;

// Cache for place results (with extended structure for multiple sizes)
interface CacheEntry {
  photos: string[];
  description?: string;
  timestamp: number;
  url?: string; // For Maps URL
}

const placeCache = new Map<string, CacheEntry>();


/**
 * Get photos for a location with enhanced context awareness and error handling
 */

// Replace getPlacePhotos function:
/* export async function getPlacePhotos_PEXELS(
  location: Location,
  options: {
    maxWidth?: number;
    maxHeight?: number;
    maxPhotos?: number;
  } = {}
): Promise<{
  photos: string[];
  description?: string;
}> {
  const maxPhotos = options.maxPhotos || MAX_PHOTOS;
  
  console.log('[Places] Fetching Pexels photos for:', location.name);
  
  // Cache check (keep existing cache logic)...
  
  try {
    // Throttle check (keep existing throttle logic)...
    
    const searchQuery = location.name.split(',')[0].trim();
    
    // Or better, check first:
    if (!PEXELS_API_KEY) {
      console.error('[Places] No Pexels API key found');
      return { photos: [DEFAULT_PLACEHOLDER] };
    }

    // Pexels API call
    const response = await fetch(
      `https://api.pexels.com/v1/search?query=${encodeURIComponent(searchQuery)}&per_page=${maxPhotos}&orientation=landscape`,
      {
        headers: {
          'Authorization': PEXELS_API_KEY // No 'Client-ID' prefix!
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Pexels API error: ${response.status}`);
    }
    
    const data = await response.json();
    
    const photos = data.photos?.map((photo: any) => photo.src.large) || [];
    
    const result = {
      photos: photos.length > 0 ? photos : [DEFAULT_PLACEHOLDER],
      description: location.description || 'No description'
    };
    
    // Cache the results (keep existing cache logic)...
    
    return result;
  } catch (error) {
    console.error('[Places] Error fetching Pexels photos:', error);
    return {
      photos: [DEFAULT_PLACEHOLDER]
    };
  }
} */

export async function getPlacePhotos(
  location: Location,
  options: {
    maxWidth?: number;
    maxHeight?: number;
    maxPhotos?: number;
  } = {}
): Promise<{
  photos: string[];
  description?: string;
}> {
  const maxPhotos = options.maxPhotos || MAX_PHOTOS;
  const maxWidth = options.maxWidth || 800;
  
  console.log('[Places] Fetching photos for:', location.name);
  
  // Cache check
  const cacheKey = `photos_${location.id || location.name}_${maxWidth}`;
  const cached = placeCache.get(cacheKey);
  
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    console.log('[Places] Cache hit for photos:', location.name);
    return {
      photos: cached.photos,
      description: cached.description
    };
  }
  
  try {
    let photos: string[] = [];
    
    // If location has a placeId, fetch fresh photos from Google Places
    /* if ((location as any).placeId && (location as any).placeId !== 'fallback') {
      console.log('[Places] Fetching fresh Google Places photos for placeId:', (location as any).placeId);
      
      const API_KEY = '312561994bmsh2d4617eda437d5ap125aa0jsn5dc8951c0810';
      const API_HOST = 'google-map-places-new-v2.p.rapidapi.com';
      
      // Search for the place again to get fresh photo data
      const requestBody = {
        textQuery: `${location.name}, ${location.city}, ${location.country}`,
        maxResultCount: 1,
        languageCode: 'en'
      };
      
      const response = await fetch('https://google-map-places-new-v2.p.rapidapi.com/v1/places:searchText', {
        method: 'POST',
        headers: {
          'x-rapidapi-key': API_KEY,
          'x-rapidapi-host': API_HOST,
          'Content-Type': 'application/json',
          'X-Goog-FieldMask': '*'
        },
        body: JSON.stringify(requestBody)
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.places && data.places[0] && data.places[0].photos) {
          console.log('[Places] Found fresh photos:', data.places[0].photos.length);
          
          // Extract photoUris
          photos = data.places[0].photos.slice(0, maxPhotos).map((photo: any) => {
            if (photo.photoUri) {
              // Adjust size parameter in the URL
              return photo.photoUri.replace(/=w\d+-h\d+/, `=w${maxWidth}`);
            }
            return '';
          }).filter((url: string) => url);
        }
      }
    } */
    
    // If no Google photos or not enough, fallback to Pexels
    if (photos.length < maxPhotos) {
      //console.log('[Places] Falling back to Pexels API', maxPhotos);
      
      // Throttle check
      const now = Date.now();
      const timeSinceLastRequest = now - lastRequestTimestamp;
      if (timeSinceLastRequest < REQUEST_THROTTLE) {
        await new Promise(resolve => setTimeout(resolve, REQUEST_THROTTLE - timeSinceLastRequest));
      }
      lastRequestTimestamp = Date.now();
      
      const searchQuery = location.name.split(',')[0].trim();
      
      const response = await fetch(
        `https://api.pexels.com/v1/search?query=${encodeURIComponent(searchQuery)}&per_page=${maxPhotos - photos.length}&orientation=landscape`,
        {
          headers: {
            'Authorization': PEXELS_API_KEY
          }
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        const pexelsPhotos = data.photos?.map((photo: any) => {
          if (maxWidth <= 400) return photo.src.small;
          if (maxWidth <= 800) return photo.src.medium;
          if (maxWidth <= 1200) return photo.src.large;
          return photo.src.original;
        }) || [];
        
        photos = [...photos, ...pexelsPhotos].slice(0, maxPhotos);
      }
    }
    
    const result = {
      photos: photos.length > 0 ? photos : [DEFAULT_PLACEHOLDER],
      description: (location as any).description || (location as any).formattedAddress || 'No description available'
    };
    
    // Cache the results
    placeCache.set(cacheKey, {
      ...result,
      timestamp: Date.now()
    });
    
    return result;
    
  } catch (error) {
    console.error('[Places] Error fetching photos:', error);
    return {
      photos: [DEFAULT_PLACEHOLDER],
      description: (location as any).description
    };
  }
}


/**
 * Get thumbnails for a location (smaller, faster loading)
 */

export async function getPlaceThumbnails(
  location: Location, 
  maxPhotos = 6
): Promise<{
  photos: string[];
  description?: string;
}> {
  // Unsplash already provides different sizes, just use the same function
  const result = await getPlacePhotos(location, { maxPhotos });
  
  // Use smaller size URLs from Unsplash
  return {
    photos: result.photos.map(url => 
      url.replace('regular', 'small') // Change to small size
    ),
    description: result.description
  };
}
/* export async function getPlaceThumbnails(
  location: Location, 
  maxPhotos = 6
): Promise<{
  photos: string[];
  description?: string;
}> {
  return getPlacePhotos(location, {
    maxWidth: 150,
    maxHeight: 150,
    maxPhotos
  });
} */

/**
 * Get high-quality photos for a location
 */
export async function getHighQualityPhotos(
  location: Location, 
  maxPhotos = 5
): Promise<{
  photos: string[];
  description?: string;
}> {
  // Use full size from Unsplash
  const result = await getPlacePhotos(location, { maxPhotos });
  
  return {
    photos: result.photos.map(url => 
      url.replace('regular', 'full') // Change to full size
    ),
    description: result.description
  };
}
/**
 * Build a context-aware search query for better place finding
 */
function buildSearchQuery(location: Location): string {
  // Extract context from location name
  const parts = location.name.split(',');
  const placeName = parts[0].trim();
  
  // Look for a city in the location name
  let city = '';
  if (parts.length > 1) {
    city = parts[1].trim();
  }
  
  // If we don't have a city from the name but have a city in context, use it
  if (!city && location.city) {
    city = location.city;
  }
  
  // If we still don't have a city, try to use location context from cityContext
  if (!city && window.cityContext?.currentCity) {
    city = window.cityContext.currentCity;
  }
  
  // Construct a query that includes location context
  let searchQuery = placeName;
  if (city) {
    // Make sure the city isn't already in the placeName
    if (!placeName.toLowerCase().includes(city.toLowerCase())) {
      searchQuery = `${placeName}, ${city}`;
    }
  }
  
  return searchQuery;
}

/**
 * Find a place and return Google Maps URL
 */

export async function findPlace(location: Location): Promise<string> {
  try {
    // Generate cache key
    const cacheKey = `url_${location.id || location.name}`;
    
    // Check cache first
    const cached = placeCache.get(cacheKey);
    if (cached && cached.url && (Date.now() - cached.timestamp < CACHE_DURATION)) {
      console.log('[Places] Cache hit for maps URL:', location.name);
      return cached.url;
    }

    // Build a Google Maps search URL using just coordinates and name
    const encodedName = encodeURIComponent(location.name);
    const url = `https://www.google.com/maps/search/?api=1&query=${encodedName}&center=${location.position.lat},${location.position.lng}`;
    
    // Cache the result
    placeCache.set(cacheKey, {
      url,
      timestamp: Date.now(),
      photos: [],
    });

    return url;
  } catch (error) {
    console.error('[Places] Error creating maps URL:', error);
    // Fallback to just coordinates
    return `https://www.google.com/maps/search/?api=1&query=${location.position.lat},${location.position.lng}`;
  }
}


// Clean up expired cache entries periodically
setInterval(() => {
  const now = Date.now();
  for (const [key, value] of placeCache.entries()) {
    if (now - value.timestamp > CACHE_DURATION) {
      placeCache.delete(key);
    }
  }
}, CACHE_DURATION);